
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType = typeof ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType[keyof typeof ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageListResponsePageAllOfThreeContentItemAllOfOnezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
